import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import Card from "react-bootstrap/Card";

export default function BoxOfficeSalePieChart({ arr }) {
  if (!arr) return "";

  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      backgroundColor: "none",
      height: 380,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.point.name}</b> sold <b>${this.point.percentage.toFixed(1)}%</b> of the tickets`;
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format:
            '<span style="font-size: 1.2em"><b>{point.name}</b>' +
            "</span><br>" +
            '<span style="opacity: 0.6;color:#777E90">{point.percentage:.1f} ' +
            "%</span>",
          connectorColor: "rgba(128,128,128,0.5)",
        },
      },
    },
    series: [
      {
        name: "Share",
        data: arr,
      },
    ],
  };

  return (
    <Card body className="card--md card-with-border">
      <div className="card-body-heading card-body-heading--sm">
        <Card.Title as="h5">Box Office Sales by Agent</Card.Title>
        <Card.Subtitle as="h6" className="mt-2">
          Detailed breakdown showing sales by agent
        </Card.Subtitle>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
}
